// @ts-nocheck
import {
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Flex,
  Tooltip,
  IconButton,
  Text,
} from '@chakra-ui/react'
import { useTable, usePagination, Column } from 'react-table'
import {
  FaArrowLeft,
  FaChevronLeft,
  FaArrowRight,
  FaChevronRight,
} from 'react-icons/fa'

const CustomTable = ({
  columns,
  data,
  size = 'lg',
  getCellProps = () => ({}),
  getColumnProps = () => ({}),
}: {
  columns: Column[]
  data: Record<string, unknown>[]
  size?: 'sm' | 'md' | 'lg'
  getCellProps: (cellInfo: any) => Record<string, any>
  getColumnProps: (columnInfo: any) => Record<string, any>
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0 },
    },
    usePagination
  )

  // Render the UI for your table
  return (
    <>
      <Table size={size} {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  {...column.getHeaderProps([
                    {
                      isNumeric: column.isNumeric ?? false,
                    },
                    getColumnProps(column),
                  ])}
                >
                  {column.render('Header')}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <Tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <Td
                      {...cell.getCellProps([
                        {
                          isNumeric: cell.column.isNumeric ?? false,
                        },
                        getCellProps(cell),
                      ])}
                    >
                      {cell.render('Cell')}
                    </Td>
                  )
                })}
              </Tr>
            )
          })}
        </Tbody>
      </Table>

      <Flex justifyContent="space-between" m={4} alignItems="center">
        <Flex>
          <Tooltip label="First Page">
            <IconButton
              aria-label="First Page"
              onClick={() => gotoPage(0)}
              isDisabled={!canPreviousPage}
              icon={<FaArrowLeft style={{ width: '1rem', height: '1rem' }} />}
              mr={4}
            />
          </Tooltip>
          <Tooltip label="Previous Page">
            <IconButton
              aria-label="Previous Page"
              onClick={previousPage}
              isDisabled={!canPreviousPage}
              icon={<FaChevronLeft style={{ width: '1rem', height: '1rem' }} />}
            />
          </Tooltip>
        </Flex>

        <Flex alignItems="center">
          <Text flexShrink="0" mr={8}>
            Page{' '}
            <Text fontWeight="bold" as="span">
              {pageIndex + 1}
            </Text>{' '}
            of{' '}
            <Text fontWeight="bold" as="span">
              {pageOptions.length}
            </Text>
          </Text>
        </Flex>

        <Flex>
          <Tooltip label="Next Page">
            <IconButton
              aria-label="Next Page"
              onClick={nextPage}
              isDisabled={!canNextPage}
              icon={
                <FaChevronRight style={{ width: '1rem', height: '1rem' }} />
              }
            />
          </Tooltip>
          <Tooltip label="Last Page">
            <IconButton
              aria-label="Previous Page"
              onClick={() => gotoPage(pageCount - 1)}
              isDisabled={!canNextPage}
              icon={<FaArrowRight style={{ width: '1rem', height: '1rem' }} />}
              ml={4}
            />
          </Tooltip>
        </Flex>
      </Flex>
    </>
  )
}

export default CustomTable
